import { Component, Input } from '@angular/core';
import { selectPlansData } from './select-plans.model';

import { environment } from '../../../../../../apps/portal/src/environments/environment';

@Component({
  selector: 'fcp-bottom-nav-modal',
  templateUrl: 'bottom-nav-modal.component.html',
  styleUrls: ['./bottom-nav-modal.component.scss']
})

export class BottomNavModalComponent {
  @Input() data: any;
  selectedPlano;
  selectedPatrocinadora;
  selectedCategoria;
  selectedRegiao;
  planos;
  patrocinadoras;
  categorias;
  regioes;
  redes;
  dataPlanos = selectPlansData;
  dataFilter;
  searchParam;
  planId;
  redeEssencial;
  selectedOdonto: boolean;

  constructor() {
    this.selectedOdonto = false;
  }

  ngOnInit() {
    this.planos = Array.from(new Set(this.dataPlanos.map(a => a.planoPai))).sort();
    if (this.data) {
      this.selectedPlano = this.data[0];
      this.filterPlano(this.data[0]);
    }
  }

  refineLists(key) {
    return Array.from(new Set(this.dataFilter.map(a => a[key]))).sort();
  }

  getLists() {
    this.patrocinadoras = this.refineLists('patrocinadora');
    this.categorias = this.refineLists('categoria');
    this.regioes = this.refineLists('abrangencia');
    this.selectedPatrocinadora = null;
    this.selectedCategoria = null;
    this.selectedRegiao = null;
  }

  getListsPatrocinador() {
    this.categorias = this.refineLists('categoria');
    this.regioes = this.refineLists('abrangencia');
  }

  getListsRegiao() {
    this.patrocinadoras = this.refineLists('patrocinadora');
    this.categorias = this.refineLists('categoria');
  }

  filterPlano(plano) {
    const results = this.dataPlanos.filter(a => a.planoPai == plano);
    this.dataFilter = results;
    this.getLists();
    this.searchParam = null;
    this.redeEssencial = null;
  }

  filterPatrocinadora(patrocinadora) {
    const results = this.dataPlanos.filter(a => a.patrocinadora == patrocinadora && a.planoPai == this.selectedPlano);
    this.dataFilter = results;
    this.getListsPatrocinador();
    this.searchParam = null;
    this.redeEssencial = null;
  }

  filterRegiao(regiao) {
    const results = this.dataPlanos.filter(a => a.abrangencia == regiao);
    if (results) {
      this.dataFilter = results;
      this.getListsRegiao();
      this.searchParam = null;
      this.redeEssencial = this.dataFilter[0].rede_essencial;
    }
  }

  selectPlano(plano) {
    const results = this.dataPlanos.filter(a => a.nome == plano.nome && a.codigo_envio == plano.codigo_envio)[0];
    this.planId = results.plano;
    this.searchParam = results.codigo_envio + '&registroAns=' + results.registroAns;
  }

  public submit() {
    // if (this.searchParam) {
    //   if (this.planId === '200') {
    //     window.open('https://facgeofuncesp.facilinformatica.com.br/', '_blank');
    //   } else {
    //     window.open(environment.redeCredenciadaUrl + this.searchParam);
    //   }
    // }
    window.open('https://vivest.odontoprev.com.br', '_blank');
  }

  public linkRedeEssencial() {
    window.open(environment.redeEssencialBaseUrl + this.redeEssencial + '.pdf');
  }

  public linkSaudeVivest() {
    this.selectedOdonto = false;
    this.selectedPlano = "";
    this.selectedPatrocinadora = "";
    this.selectedCategoria = "";
    window.open('https://facgeofuncesp.facilinformatica.com.br/', '_blank');
  }

  public linkSaudeNacional() {
    this.selectedOdonto = false;
    this.selectedPlano = "";
    this.selectedPatrocinadora = "";
    this.selectedCategoria = "";
    window.open('https://www.unimedfesp.coop.br/guia-medico', '_blank');
  }

  public linkOdontologicaNacional() {
    this.selectedOdonto = true;
  }
}
